import PortalIdParser from 'PortalIdParser';
import apiClient from 'hub-http/clients/noAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { createViewSessionRpc, finishPageRpc, nextPageRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsViewSessionPublicService';
const baseUrl = 'presentations/v1/revisit';
export function createActivity(presentationId, accessId, viewer) {
  return apiClient.post(`${baseUrl}/async/${presentationId}`, {
    query: {
      portalId: PortalIdParser.get(),
      accessId
    },
    data: viewer
  });
}
export const createActivityCHIRP = async ({
  accessId,
  documentId,
  viewer
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(createViewSessionRpc, {
    request: {
      accessId,
      sharedLinkId: documentId,
      userAgent: '',
      // TODO: what does this need to be?
      viewer
    }
  });
  return response;
};

// returns 204 No Content
export function viewPage(presentationId, accessId, activityId, pageIndex) {
  return apiClient.post(`${baseUrl}/${presentationId}/${activityId}/page/${pageIndex}`, {
    query: {
      portalId: PortalIdParser.get(),
      accessId
    }
  });
}
export const startPageCHIRP = async ({
  accessId,
  activityId,
  documentId,
  pageNumber,
  viewerId
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(nextPageRpc, {
    request: {
      accessId,
      mobile: false,
      pageNumber,
      sharedLinkId: documentId,
      userId: viewerId,
      // TODO: verify that we should be using viewerId here
      viewSessionId: activityId
    }
  });
  return response;
};

// returns 204 No Content
export function finishActivity(presentationId, accessId, activityId) {
  return apiClient.post(`${baseUrl}/${presentationId}/${activityId}/finish`, {
    query: {
      portalId: PortalIdParser.get(),
      accessId
    }
  });
}
export const finishPageCHIRP = async ({
  accessId,
  activityId,
  documentId,
  documentClosing,
  pageNumber,
  viewer
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  const response = await rpcClient.call(finishPageRpc, {
    request: {
      accessId,
      pageNumber,
      sharedLinkId: documentId,
      timestamp: Date.now(),
      viewer,
      viewSessionId: activityId,
      documentClosing
    }
  });
  return response;
};